import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, LoadingState, EmptyState, EventTime } from "@/components/Common";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { INTERACTION_TYPES } from "@/lib/constants";
import { BookOpen } from "lucide-react";

const Diario = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tipo, setTipo] = useState("tutti");

  useEffect(() => {
    setLoading(true);
    api.get("/interactions?limit=200").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);

  const filtered = tipo === "tutti" ? items : items.filter((i) => i.tipo === tipo);

  return (
    <div>
      <PageHeader icon={BookOpen} title="Diario operativo" description="Cronologia relazionale completa di tutti i contatti registrati"
        actions={<Select value={tipo} onValueChange={setTipo}><SelectTrigger className="w-[200px]"><SelectValue placeholder="Tipo evento" /></SelectTrigger><SelectContent className="max-h-64"><SelectItem value="tutti">Tutti i tipi</SelectItem>{INTERACTION_TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent></Select>} />
      {loading ? <LoadingState /> : filtered.length === 0 ? <EmptyState title="Nessun evento nel diario" /> : (
        <div className="space-y-0">
          {filtered.map((i) => (
            <div key={i.id} className="relative pl-10 pb-5 timeline-line">
              <div className="absolute left-2 top-1 h-6 w-6 rounded-full bg-[color:var(--brand-orange-100)] border-2 border-white flex items-center justify-center"><span className="h-2 w-2 rounded-full bg-[color:var(--brand-orange-600)]" /></div>
              <Card className="p-3">
                <div className="flex items-center justify-between gap-2 flex-wrap"><span className="text-sm font-medium">{i.tipo}</span><EventTime dataEvento={i.data_evento} createdAt={i.created_at} /></div>
                {i.oggetto && <div className="text-sm font-medium text-slate-700 mt-1">{i.oggetto}</div>}
                {i.descrizione && <div className="text-sm text-slate-600 mt-0.5 whitespace-pre-line">{i.descrizione}</div>}
                <div className="text-[11px] text-muted-foreground mt-1">{i.operatore_nome}{i.servizio_nome ? ` · ${i.servizio_nome}` : ""}</div>
              </Card>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Diario;
